// extracted by mini-css-extract-plugin
export default {"favouriteSection":"Favourite_favouriteSection__8UZi6","favProductsListContainer":"Favourite_favProductsListContainer__o9stP"};